var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "card-body" },
    _vm._l(_vm.posts, function (post, index) {
      return _c("div", [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-auto" }, [
            _c(
              "a",
              {
                staticClass: "avatar avatar-lg avatar-4by3",
                attrs: {
                  href: _vm.$root.url("post_view", {
                    slug: post.slug,
                    id: post.id,
                  }),
                },
              },
              [
                _c("img", {
                  staticClass: "avatar-img rounded",
                  attrs: {
                    src: post.image
                      ? post.image.sizes.small
                      : _vm.$root.asset("bundles/ornweb/img/no-thumbnail.png"),
                    alt: post.title,
                  },
                }),
              ]
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col ml-n2" }, [
            _c("h4", { staticClass: "card-title mb-1" }, [
              _c(
                "a",
                {
                  staticClass: "name text-dark",
                  attrs: {
                    href: _vm.$root.url("post_view", {
                      slug: post.slug,
                      id: post.id,
                    }),
                  },
                },
                [_vm._v(_vm._s(post.title))]
              ),
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "text-muted mb-0 small" }, [
              post.author
                ? _c(
                    "span",
                    [
                      _c("post-author", { attrs: { author: post.author } }),
                      _vm._v(" ·"),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "time",
                {
                  attrs: {
                    datetime: _vm.$root
                      .moment(post.publish_at)
                      .format("YYYY-MM-DD HH:mm:ss"),
                  },
                },
                [_vm._v(_vm._s(_vm.$root.moment(post.publish_at).fromNow()))]
              ),
            ]),
          ]),
        ]),
        _vm._v(" "),
        index < _vm.posts.length - 1 ? _c("hr") : _vm._e(),
      ])
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }